module.exports = __webpack_public_path__ + "img/professional_experiences.1de7001f.png";